<template>
  <div class="table-responsive">
    <div
      id="zero_config_wrapper"
      class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer"
    >
      <div class="row">
        <div class="col-sm-12 col-md-6"></div>
        <div class="col-sm-12 col-md-6">
          <TableSearch @handleSearch="handleSearch" :left="'left:16px'" />
        </div>
      </div>
      <div class="row" style="max-height: 22rem; overflow: auto;">
        <div class="col-sm-12">
          <table id="zero_config" class="table table-hover">
            <thead class="data-table-bg">
              <tr>
                <th
                  :key="index"
                  v-for="(column, index) in tableColumns"
                  @click="sortBy(column[1])"
                  style="cursor: pointer; text-align: left"
                >
                  {{ column[0] }}
                  <span
                    class="arrow"
                    :class="sortOrders[column[1]] > 0 ? 'asc' : 'dsc'"
                  ></span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                :key="index"
                v-for="(data, index) in paginatedData"
                style="text-align: left;"
                :class="{
                  'data-table-bg': index % 2 !== 0,
                }"
              >
                <td>{{ data.date }}</td>
                <td>{{ data.column1 }}</td>
                <td
                  :class="{
                    'text-danger': data.tempStat,
                  }"
                >
                  {{ data.column2 }}
                </td>
                <td
                  :class="{
                    'text-danger': data.humiStat,
                  }"
                >
                  {{ data.column3 }}
                </td>
                <td class="text-capitalize">{{ data.column4 }}</td>
                <td>
                  {{ data.column5 }} <br /><br />
                  {{ data.column6 }}
                </td>
              </tr>
            </tbody>
          </table>
          <div v-if="this.stats && this.stats.length == 0">
            <h4 class="text-muted">
              {{ $t("no_temp_today") }}
            </h4>
          </div>
        </div>
      </div>
      <Pagination
        :pageCount="pageCount"
        :data="stats"
        :sizeperpage="sizeperpage"
        :pageNumber="pageNumber"
        :pages="pages"
        @goToLastPage="goToLastPage"
        @nextPage="nextPage"
        @handlePageChange="handlePageChange"
        @goToFirstPage="goToFirstPage"
        @prevPage="prevPage"
        @onchange="onchange"
      />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import tableMixin from "../mixins/tableMixin";
import Pagination from "../components/PaginationNew.vue";
import TableSearch from "../components/TableSearch.vue";

export default {
  name: "Table",
  props: {
    stats: Array,
    paginationMeta: Object,
  },
  data() {
    return {
      dataTable: [],
    };
  },
  components: { Pagination, TableSearch },
  mixins: [tableMixin],
  mounted() {
    this.initialiseTable();
  },
  watch: {
    stats: {
      handler: function() {
        this.initialiseTable();
      },
      deep: true,
    },
  },

  computed: {
    tableColumns() {
      return [
        [this.$t("date_time"), "dateOrig"],
        [this.$t("dev_imei"), "column1"],
        [this.$t("temp"), "column2"],
        [this.$t("humid"), "column3"],
        [this.$t("status"), "column4"],
        [this.$t("comment"), "column5"],
      ];
    },
  },
  methods: {
    initialiseTable() {
      this.dataTable = [];

      for (let i = 0; i < this.stats?.length; i++) {
        let date = this.stats[i].deviceStat.deviceTimeStamp;
        date = moment(date).format("MMM Do YYYY, hh:mm a");
        this.dataTable.push({
          column1: this.stats[i].deviceDetails.imei,
          column3: this.stats[i].humidity.value,
          column2: this.stats[i].temperature.value,
          column4: this.stats[i].status,
          column5: this.stats[i].temperature.message,
          column6: this.stats[i].humidity.message,
          dateOrig: this.stats[i].deviceStat.deviceTimeStamp,
          tempStat: this.stats[i].temperature.excursion,
          humiStat: this.stats[i].humidity.excursion,
          date: date,
        });
      }
    },
  },
};
</script>

<style scoped>
td {
  /* border-bottom: 1px rgba(0, 0, 0, 0.1) solid; */
}

th,
td {
  min-width: 150px;
}
th.active {
  color: #fff;
}

th.active .arrow {
  opacity: 1;
}

.arrow {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 0.66;
}

.arrow.asc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 8px solid #000000;
}

.arrow.dsc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 8px solid #000000;
}
</style>

<i18n>
{
	"en": {
		"alm_val": "Alarm Value",
		"alrm_type": "Alarm Type",
		"comment": "Comment",
		"date_time": "Date/Time",
		"entries": "entries",
		"no_temp_today": "No Temperature/Humidity data available for today",
		"nxt": "Next",
		"of": "of",
		"prev": "Previous",
		"readings": "readings",
		"search": "Search",
		"show": "Show",
		"showing": "Showing",
		"stat": "Status"
	},
	"es": {
		"alm_val": "Valor de alarma",
		"alrm_type": "Tipo de alarma",
		"comment": "Comentario",
		"date_time": "Fecha y hora",
		"entries": "entradas",
		"no_temp_today": "No hay datos de temperatura / humedad disponibles para hoy",
		"nxt": "Siguiente",
		"of": "de",
		"prev": "Anterior",
		"readings": "Lecturas",
		"search": "Buscar",
		"show": "Show",
		"showing": "Demostración",
		"stat": "Estado"
	},
	"fr": {
		"alm_val": "VALEUR D'ALARME",
		"alrm_type": "Type d'alarme",
		"comment": "Commentaire",
		"date_time": "Date / heure",
		"entries": "Les entrées",
		"no_temp_today": "Aucune donnée de température/humidité disponible pour aujourd'hui",
		"nxt": "Suivant",
		"of": "De",
		"prev": "précédent",
		"readings": "Lectures",
		"search": "Chercher",
		"show": "Spectacle",
		"showing": "Montrant",
		"stat": "Statut"
	},
	"sw": {
		"alm_val": "Thamani ya Kengele",
		"alrm_type": "Aina ya Kengele",
		"comment": "Maoni",
		"date_time": "Tarehe/Saa",
		"entries": "Viingilio",
		"no_temp_today": "Hakuna data ya Halijoto/Unyevu inayopatikana kwa leo",
		"nxt": "Ifuatayo",
		"of": "ya",
		"prev": "Hapo awali",
		"readings": "usomaji",
		"search": "Tafuta",
		"show": "Onyesha",
		"showing": "Kuonesha",
		"stat": "Hali"
	}
}
</i18n>
